// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-65e617c4] .updateDialog{width:472px}[data-v-65e617c4] .updateDialog .el-select{width:100%}", ""]);
// Exports
module.exports = exports;
